import { ERRORS } from '@constants/documents.constants';

import {
  BaseDashboardViewState,
  INITIAL_DASHBOARD_VIEW_STATE,
  INITIAL_SEARCH_PARAMS,
} from '../documents.state';

export type ErroredDocumentDashboardType = typeof ERRORS;

export interface ErroredDocumentsState {
  dashboardView: BaseDashboardViewState;
}

export const INITIAL_ERRORED_DOCUMENTS_STATE: ErroredDocumentsState = {
  dashboardView: {
    ...INITIAL_DASHBOARD_VIEW_STATE,
    searchParams: { ...INITIAL_SEARCH_PARAMS, showRead: false, hideOtherRequesters: true },
  },
};
